import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-switch-pill',
  templateUrl: './switch-pill.component.html',
  styleUrls: ['./switch-pill.component.scss'],
})
export class SwitchPillComponent implements OnInit {
  @Input() isActive: boolean = false;
  @Input() id: string = '';
  @Input() pxId: string = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() position: string = 'start';
  @Input() fontSize: number = 14;
  @Input() styleClassLabel: string = '';
  @Input() tooltipText: string = '';
  @Input() tooltipPosition: string = '';
  @Output() appChange = new EventEmitter<any>();

  @ViewChild('checkboxEl') checkboxEl: ElementRef;

  constructor() {}

  ngOnInit() {}

  onChange(event: any) {
    this.appChange.emit(event.target.checked);
  }
}
